import apiRequest from '@libs/apiRequest';
import { getFormValues } from 'redux-form';
import { call, put, select } from 'redux-saga/effects';
import { FORM_NAME } from '../../common';
import { setLoading, setSnack } from 'utilities/redux.actions';
import { SHIFT } from 'common/redux.datasets';

export default function* (action) {
    const {
        meta: { handleSubmit = () => { } },
        ...rest
    } = action;

    yield put(setLoading(true));

    const allSelector = yield select(
        getFormValues(FORM_NAME)
    );

    const payloadData = JSON.stringify(allSelector)
    try {
        const { data } = yield call(
            apiRequest,
            {
                url: `shift/update?name=${allSelector.name}`,
                method: 'post',
                data: payloadData,
            }
        );
        yield put(setLoading(false));
        yield put(setSnack({
            message: "Shift updated successfully",
            type: 'success',
        }));
        yield put({
            type: "handleUpdate",
            payload: {
                entity: SHIFT,
                value: data,
                key:"name"
            },
        });
        return handleSubmit(data);
    } catch (error) {
        yield put(setLoading(false));
        yield put(setSnack({
            message: error?.response?.data?.message || error?.message,
            type: 'error',
        }));
        return handleSubmit(error);
    }
}
